var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.263,
    height: 24.263,
    viewBox: "0 0 24.263 24.263",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search",
    d: "M23.935,22.507l-6.026-6.026a10.112,10.112,0,1,0-1.428,1.428l6.026,6.026a1.01,1.01,0,1,0,1.428-1.428ZM10.1,18.173A8.077,8.077,0,1,1,18.173,10.1,8.077,8.077,0,0,1,10.1,18.173Z",
    transform: "translate(0.032 0.032)",
    fill: "#adadad"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e98128a619790e5e6a6333603469ef0e.svg";
export { ForwardRef as ReactComponent };